










import { Vue, Component, Prop } from 'vue-property-decorator';
import { Step } from '@/interfaces/Step';

@Component({})
export default class StepCard extends Vue {
  @Prop()
  step!: Step;

  get stepName() {
    const stepLanguage = this.step.stepLanguages.find(
      (sL) => sL.langaugeId === this.$store.state.user.languageId
    );
    console.log(this.step);
    return stepLanguage?.name || this.step.stepLanguages[0]?.name || '';
  }
}
